import { Button } from "@/components/ui/button";
import { ArrowRightIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function TestPage() {

  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col gap-3 items-center justify-center h-screen">
      <span className="font-instrument-serif leading-tight text-2xl">
        Huh, what are you doing in the test page?
      </span>
      <Button onClick={() => navigate("/dashboard")}>
        Go to campaigns
        <ArrowRightIcon/>
      </Button>
    </div>
  );
}
